import { render, staticRenderFns } from "./IndexDescentralizacao.vue?vue&type=template&id=26ca10b9&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./IndexDescentralizacao.vue?vue&type=style&index=0&id=26ca10b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ca10b9",
  null
  
)

export default component.exports